// removed by extract-text-webpack-plugin
module.exports = {"reset":"_3AyVk44RYyh619Kwq2RWfM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Reset/Reset.scss
// module id = 659
// module chunks = 0